"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPUKCodeComponent = void 0;
const helper_service_1 = require("../../services/helper.service");
const account_service_1 = require("../../services/account.service");
const searchfilter_pipe_1 = require("../../pipes/searchfilter.pipe");
const _ = require("underscore");
class CSPUKCodeComponent {
    constructor(accountService, helperService) {
        this.accountService = accountService;
        this.helperService = helperService;
        this.pager = {};
        this.sortFilterArray = ['1-10', '20 lines', '50 lines', '100 lines'];
    }
    ngOnInit() {
        var _a;
        if (this.subList) {
            this.subList = (_a = this.subList) === null || _a === void 0 ? void 0 : _a.filter(function (subscription) {
                var _a;
                if ((_a = subscription === null || subscription === void 0 ? void 0 : subscription.device) === null || _a === void 0 ? void 0 : _a.uiccId) {
                    return subscription;
                }
            });
        }
        this.filteredSubscriptions = _.clone(this.subList).filter((sub) => sub.fixedWireless !== true);
        this.callSortNumber = '1-10';
        this.onSelectSort(this.callSortNumber);
        this.htmlString = '<button class="btn btn-outline-primary py-2">GET VERIFIED</button>';
    }
    getPukCodeForSub(subId) {
        this.loader = true;
        this.subscriptionId = subId;
        this.accountService.getPukCode(subId).subscribe((res) => {
            this.pukCode = res;
            if (this.subList && this.subList.length > 0) {
                for (let index = 0; index < this.subList.length; index++) {
                    if (this.subList[index].subscriptionId === subId) {
                        this.subList[index].puk = this.pukCode;
                        this.subList[index].show = true;
                        break;
                    }
                }
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    onSelectSort(selectNumber) {
        this.setPage(1, selectNumber);
        if (selectNumber === '1-10') {
            this.sortNumber = 10;
        }
        else if (selectNumber === '20 lines') {
            this.sortNumber = 20;
        }
        else if (selectNumber === '50 lines') {
            this.sortNumber = 50;
        }
        else if (selectNumber === '100 lines') {
            this.sortNumber = 100;
        }
        this.setPage(this.pager.currentPage, this.sortNumber);
    }
    setPage(page, pageSize) {
        if (this.pager.totalPages !== 0) {
            if (page < 1 || page > this.pager.totalPages) {
                return;
            }
        }
        if (pageSize === '1-10') {
            pageSize = 10;
        }
        else if (pageSize === '20 lines') {
            pageSize = 20;
        }
        else if (pageSize === '50 lines') {
            pageSize = 50;
        }
        else if (pageSize === '100 lines') {
            pageSize = 100;
        }
        // get pager object from service
        if (this.filteredSubscriptions && page) {
            this.pager = this.helperService.getPager(this.filteredSubscriptions.length, page, pageSize);
            this.startIndex = this.pager.startIndex;
            this.endIndex = this.pager.endIndex + 1;
        }
    }
    onInputSearchChange(searchText) {
        const searchPipe = new searchfilter_pipe_1.SearchFilterPipe();
        const searchTextWithoutDashes = this.sanitizePhoneNumber(searchText);
        // eslint-disable-next-line max-len
        this.filteredSubscriptions = searchPipe.transform(this.subList, { 'mobileNumber': searchTextWithoutDashes, 'subscriberBusinessName': searchText, 'esnMeid': searchText, 'modelNumber': searchText, 'isSearchData': true }, false);
        this.callSortNumber = '1-10';
        this.onSelectSort(this.callSortNumber);
        this.searchQuery = searchText;
    }
    sanitizePhoneNumber(phoneNumber) {
        // Remove dashes from the phone number
        return phoneNumber.replace(/-/g, '');
    }
    pinVerify(event) {
        this.cpniVerified = event ? true : false;
    }
}
exports.CSPUKCodeComponent = CSPUKCodeComponent;
//# sourceMappingURL=puk-code.component.js.map